import { buildRoomWebSocketUrl } from "@infrastructure/websocket/roomWebSocketUrl";
import { WebSocketConnection } from "@infrastructure/websocket/WebSocketConnection";
import { IWebSocketReceiver } from "@/types/interfaces";
import { WebSocketData, WebSocketDataSchema } from "@/types/types";

class RoomWebsocketController implements IWebSocketReceiver {
	private readonly connection: WebSocketConnection;

	constructor(roomId: string) {
		this.connection = new WebSocketConnection({ url: buildRoomWebSocketUrl(roomId) });
	}

	public handleWebSocketConnection(onMessageHandler: (data: WebSocketData) => void): void {
		this.connection.setOnMessage((event) => {
			const parsed = WebSocketDataSchema.parse(JSON.parse(event.data));
			onMessageHandler(parsed);
		});
	}

	public onMessage(callback: (data: WebSocketData) => void): void {
		this.handleWebSocketConnection(callback);
	}

	public onError(): void {}
	public onClose(): void {}
	public onOpen(): void {}

	public close(): void {
		this.connection.destroy();
	}
}

export default RoomWebsocketController;
